import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/channels/guest` is the GUEST-FACING audience segment.
// The Channels LAYOUT route (channels.tsx) derives `audience` from the matched
// route id and filters the list to guest-facing channels. Mirrors forms markers.
export const Route = createFileRoute("/$orgSlug/$eventSlug/channels/guest")({
  component: () => null,
})
